import PageHeader from "src/components/pageHeader";
import { useGetWithdrawalRequestsQuery, useCountWithdrawalRequestsQuery } from "../withdrawal-requests.service";
import { WithdrawalRequest } from "../types/withdrawal-request.entity";
import usePagination from "src/customHooks/usePagination";
import Pagination from "src/components/pagination";
import WithdrawalTable from "../components/withdrawalRequests/withdrawalRequestsTable";
import { WithdrawalRequestsTableSkeleton } from "../components/withdrawalRequests/WithdrawalRequestsTableSkeleton";
import { Navigate } from "react-router-dom";
import PageLoading from "src/components/pageLoading";
import { useTheme } from "src/context/theme.context";

const WithdrawalRequests = () => {
  const { isDarkMode } = useTheme();
  const { data, numberOfPages, currentPage, next, prev, isSuccess, isError, isLoading, isFetching } = usePagination<WithdrawalRequest>({
    useGetDataQuery: useGetWithdrawalRequestsQuery,
    useCountData: useCountWithdrawalRequestsQuery,
  });

  return isSuccess ? (
    <div className="page_container">
      <PageHeader text="Withdrawal Requests" />
      {isSuccess ? (
        <>
          {isLoading || isFetching ? (
            <div className="overflow-x-auto mb-6">
              <table
                className={`min-w-full border divide-y ${
                  isDarkMode ? "border-gray-700 divide-gray-700 bg-gray-900" : "border-gray-200 divide-gray-200 bg-white"
                }`}
              >
                <thead className="bg-gray-800 text-white text-center">
                  <tr>
                    <th className="px-4 py-3">User Name</th>
                    <th className="px-4 py-3">User Email</th>
                    <th className="px-4 py-3">User Role</th>
                    <th className="px-4 py-3">Account Type</th>
                    <th className="px-4 py-3">Amount</th>
                    <th className="px-4 py-3">Status</th>
                    <th className="px-4 py-3">Date</th>
                    <th className="px-4 py-3">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <WithdrawalRequestsTableSkeleton rows={10} />
                </tbody>
              </table>
            </div>
          ) : (
            <WithdrawalTable withdrawalRequests={data} />
          )}
          <Pagination numberOfPages={numberOfPages} currentPage={currentPage} prev={prev} next={next} isLoading={isLoading || isFetching} />
        </>
      ) : null}
    </div>
  ) : isError ? (
    <Navigate to="/505" />
  ) : (
    <PageLoading />
  );
};

export default WithdrawalRequests;
